module.exports = __webpack_public_path__ + "frontend/img/icon-account-add.b0e40696.svg";